import { render, staticRenderFns } from "./DbPushModal.vue?vue&type=template&id=330c3012&scoped=true&"
import script from "./DbPushModal.vue?vue&type=script&lang=ts&"
export * from "./DbPushModal.vue?vue&type=script&lang=ts&"
import style0 from "./DbPushModal.vue?vue&type=style&index=0&id=330c3012&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330c3012",
  null
  
)

export default component.exports